import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import Path from '../../assets/images/Happay Loader.gif';

function Loader(props) {
  const [state, setState] = useState({
    show: false,
  });
  useEffect(() => {
    setState({
      show: props.loader,
    });
  }, [props]);

  return (
    <>
      {state.show && (
        <div className="happay-loader">
          <img alt="animated" src={Path} height="100px" />
        </div>
      )}
    </>
  );
}

Loader.propTypes = {
  loader: PropTypes.bool,
};

export default Loader;
